import styled from 'styled-components'

import type { HTMLAttributes } from 'react'

export function Skeleton({
  count = 1,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  count?: number
}) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <StSkeleton {...props} key={index} />
      ))}
    </>
  )
}

const StSkeleton = styled.span`
  display: inline-block;
  height: 1lh;
  color: inherit;
  background-color: ${({ theme }) => theme.Colors.Neutrals.Light};
  border-radius: ${({ theme }) => theme.UI.BorderRadius.Small}px;
  width: 100%;
`
